"use strict";

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports.default = function () {
    (0, _jquery2.default)("a[data-toggle='updateImageId'][data-target][data-id]").click(function (e) {
        e.preventDefault();

        var $t = (0, _jquery2.default)(this);
        var $target = (0, _jquery2.default)($t.data("target"));
        var id = $t.data("id");

        var modal = $t.data("modal");
        if (modal) {
            (0, _jquery2.default)(modal).modal("hide");
        }

        $target.val(id);
    });
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/updateImageId.js
// module id = 457
// module chunks = 0